export function array<K extends keyof any, V, T>(
    generator: (key: K, value?: V) => T,
    data?: number | { [P in K]: V })
    : T[] & { generator: (key: K, value?: V) => T } {

    const ar: T[] & { generator: (key: K, value?: V) => T } = [] as any;
    ar.generator = generator;
    if (typeof data === "number") {
        for (let i = 0; i < data; i++) {
            ar.push(generator(i as K));
        }
    } else if (typeof data === "object") {
        for (const p of Object.getOwnPropertyNames(data)) {
            ar.push(generator(p as K, (data as any)[p]));
        }
    }
    return ar;
}
